import type { WidgetOutput } from "../types/widget";

export const OUTPUT_FORMAT_OPTIONS: Array<{
  value: NonNullable<WidgetOutput["format"]>;
  label: string;
}> = [
  { value: "echarts", label: "ECharts" },
  { value: "table", label: "Table" },
  { value: "text", label: "Text" },
  { value: "html", label: "HTML" },
];

export const DEFAULT_ECHARTS_MAPPING_JSON = `{
  "chartType": "bar",
  "optionTemplate": {
    "title": { "text": "{{widget.name}}" },
    "xAxis": { "type": "category", "data": [] },
    "yAxis": { "type": "value" },
    "series": [{ "type": "bar", "data": [] }]
  }
}`;

export const DEFAULT_TABLE_MAPPING_JSON = `{
  "columns": []
}`;

export const DEFAULT_TEXT_TEMPLATE = "{{widget.name}}: {{value}}";
